module.exports = __webpack_public_path__ + "media/MRI3.299f24ee.mp3";